export const copyToClipboard = async (
  text: string,
  onSuccess?: () => void
): Promise<void> => {
  if (!navigator.clipboard) {
    throw new Error('Clipboard API not supported in this browser');
  }

  if (!globalThis.isSecureContext) {
    throw new Error(
      'Clipboard API requires a secure context (HTTPS or localhost)'
    );
  }

  try {
    await navigator.clipboard.writeText(text);
    onSuccess?.();
  } catch (error) {
    console.error('Failed to copy text: ', error);
    throw new Error(
      'Failed to copy to clipboard. Permission denied or unsupported.'
    );
  }
};
